import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-teal-200 py-5" data-id="element-57">
      <button className="flex justify-between items-center w-full text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-58">
        <h4 className="text-lg font-medium text-teal-900" data-id="element-59">{question}</h4>
        {isOpen ? <ChevronUpIcon className="h-5 w-5 text-teal-700" data-id="element-60" /> : <ChevronDownIcon className="h-5 w-5 text-teal-700" data-id="element-61" />}
      </button>
      {isOpen && <div className="mt-3 text-gray-700" data-id="element-62">{answer}</div>}
    </div>;
};
const FAQSection = () => {
  const faqs = [{
    question: 'Can I really add unlimited clients?',
    answer: "Yes. Just email us their addresses after you sign up. We'll create and manage their accounts for you."
  }, {
    question: 'Do my clients see my name or practice inside the platform?',
    answer: 'No—they just get access to the Neurotoned platform and tools.'
  }, {
    question: 'What if I want to stop after a year?',
    answer: "You can cancel anytime. You'll keep your access until your billing cycle ends."
  }, {
    question: 'Do I have to lead the live calls?',
    answer: 'Nope! Our practitioners handle all biweekly support sessions.'
  }];
  return <section id="faq" className="py-20 px-6 md:px-12 bg-teal-50" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <h2 className="text-3xl font-bold text-teal-900 text-center mb-12" data-id="element-65">
          Frequently Asked Questions
        </h2>
        <div className="bg-white p-8 rounded-xl shadow-md" data-id="element-66">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-67" />)}
        </div>
      </div>
    </section>;
};
export default FAQSection;